import { render, staticRenderFns } from "./metopeOrderForm.vue?vue&type=template&id=37c7a095&scoped=true&"
import script from "./metopeOrderForm.vue?vue&type=script&lang=js&"
export * from "./metopeOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./metopeOrderForm.vue?vue&type=style&index=0&id=37c7a095&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c7a095",
  null
  
)

export default component.exports